/**
 * Add a loading spinner to a button element
 * @param {HTMLElement} button 
 */
export const loadingSpinner = (button) => {
  const spinner = button.querySelector(
    ".loading-overlay__spinner"
  );
  if (spinner) spinner.classList.remove("hidden");
  button.classList.add("loading");
  setTimeout(() => {
    spinner.classList.add("hidden");
    button.classList.remove("loading");
  }, 2000);
};